import { Box, Text } from '@factorialco/deprecated-design-system'
import { Organization as OrganizationIcon } from '@factorialco/f0-react/icons/app'
import { NodeProps } from '@xyflow/react'

import i18n from 'modules/core/lib/i18n'

import { And } from 'modules/workflows/components/Partials/And'
import { Operator } from 'modules/workflows/components/Partials/Operator'

import { NodeUI, isNodePropsConditionIf } from './types'

export const FlowNodeSwitchCondition = (props: NodeProps<NodeUI>) => {
  if (!isNodePropsConditionIf(props)) return

  const comparison = props.data.comparison
  if (!comparison) return null

  const expressions = comparison.expression?.root?.expressions ?? []

  return (
    <Box
      position="relative"
      flexDirection="row"
      width="s360"
      alignItems="flexStart"
      justifyContent="spaceBetween"
      borderRadius={{ all: 'abs012' }}
      background="white"
      border={{ all: { style: 'solid', color: 'grey400', width: 's2' } }}
      style={{ borderColor: '#CDECEF' }}
      padding="s12"
      gap="s8"
    >
      <Box flexDirection="column" alignItems="flexStart" justifyContent="center" gap="s8">
        {expressions.length === 0 && (
          <Box flexDirection="row" gap="s4">
            <Text color="textCritical" weight="medium" size="200">
              {i18n.t('workflows.node_type.condition.no_expressions')}
            </Text>
          </Box>
        )}
        {expressions.map((expression, index) => {
          let leftName = expression.left.name
          leftName = leftName.charAt(0).toUpperCase() + leftName.slice(1)

          return (
            <Box
              flexDirection="row"
              flexWrap="wrap"
              gap="s4"
              style={{ maxWidth: '290px' }}
              key={index}
            >
              {index !== 0 && comparison.expression?.root?.operator === 'and' && <And />}
              <Text color="textPrimary" weight="medium" size="200">
                {leftName}
              </Text>
              <Operator operator={expression.operator} />
              <Text weight="medium" size="200">
                {expression.right.value}
              </Text>
            </Box>
          )
        })}
      </Box>

      <Box
        position="absolute"
        paddingX="s4"
        paddingY="s2"
        height="min-content"
        borderRadius={{ all: 'abs010' }}
        border={{ all: { style: 'solid', color: 'grey400', width: 's1' } }}
        flexDirection="row"
        alignItems="center"
        gap="s2"
        style={{ top: '12px', right: '12px' }}
      >
        <OrganizationIcon width={16} height={16} color="textPrimary" />
        <Text size="100" color="textPrimary" weight="medium">
          {comparison.priority}
        </Text>
      </Box>
    </Box>
  )
}
